import { SolidifyableData } from "@lib/titan2/dist/api/core/data/SolidifyableData";
import { SlingoConstants } from "../enum/SlingoConstants";
/*
 * SpinPriceData.ts
 */
export class SpinPriceData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.stakeAmount = this.data.getNumber(SlingoConstants.PROPERTY_STAKE_AMOUNT);
        }
    }
    getStakeAmount() {
        return this.stakeAmount;
    }
}
//# sourceMappingURL=SpinPriceData.js.map